export default {
  data() {
    return {
      errorMessage: null,
      errorTimeout: null
    }
  },
  methods: {
    showError(message) {
      this.errorMessage = message
      clearTimeout(this.errorTimeout)
      this.errorTimeout = setTimeout(() => {
        this.errorMessage = null
      }, 3000)
    }
  },
  beforeUnmount() {
    clearTimeout(this.errorTimeout)
  }
}
